<template>
    <div class="switch" :style="{backgroundColor:toggle?activeColor:inactiveColor}" :class="{checked:toggle,openStatus:toggle,[size]:true}" ref="switch" @click="switchChecked">
        <div class="switch-open" v-if="toggle">
            <slot name="open"></slot>
        </div>
        <div  class="switch-close" v-if="!toggle">
            <slot name="close"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "x-switch",
        props:{
            activeColor:{
                type:String,
            },
            inactiveColor:{
                type:String
            },
            size:{
                validator(val){
                    return ['big','medium','small'].indexOf(val)>-1
                }
            },
            fatherToggle:Boolean
        },
        data(){
            return {
                toggle:true,
            }
        },
        mounted(){
          if(this.fatherToggle!==undefined)return this.toggle = this.fatherToggle
        },
        methods:{
            switchChecked(event){
                event.preventDefault()
                this.toggle = !this.toggle
                this.$emit('on-change',this.toggle)
            }
        },
        watch:{
            fatherToggle(){
                this.toggle = this.fatherToggle
            }
        }
    }
</script>

<style scoped lang="scss">

    .switch{
        height: 31px;
        width: 61px;
        background-color: rgba(231, 231, 231, 0.95);
        color: white;
        border-radius: 100px;
        display: inline-flex;
        position: relative;
        font-size: 14px;
        transition: all .2s ease-in-out;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        &-open{
            position: absolute;
            left: 7px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 1;
        }
        &-close{
            position: absolute;
            left: 35px;
            top: 50%;
            transform: translateY(-50%);
        }
        &::after{
            content: "";
            width: 31px;
            height: 31px;
            border-radius: 100%;
            background-color: #fff;
            position: absolute;
            left: 1px;
            top: 0;
            cursor: pointer;
            transition: left .2s ease-in-out,width .2s ease-in-out;
        }
        &.checked{
            &:after{
                left: 30px;
            }
        }
        &.openStatus{
            background-color: #2d8cf0;
            color: white;
        }
        &.big{
            height: 25px;
            width: 60px;
            font-size: 15px;
            border-radius: 22px;
            .switch-open{
                left: 10px;
                top: 1px;
            }
            .switch-close{
                left: 30px;
                top:1px;
            }
            &::after{
                width: 23px;
                height: 23px;
            }
            &.checked{
                &:after{
                    left: 36px;
                }
            }
        }
        &.small{
            height: 17px;
            width: 42px;
            font-size: 13px;
            border-radius: 18px;
            .switch-open{
                left: 7px;
                top: -1px;
            }
            .switch-close{
                left: 20px;
                top:-1px;
            }
            &::after{
                width: 15px;
                height: 15px;
            }
            &.checked{
                &:after{
                    left: 26px;
                }
            }
        }

    }
</style>
